import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import InquiryTarget from "./vue/components/inquiryTarget.vue";

const inquiryTargetAppSelector = ".inquiry-target-app";
const inquiryTargetAppElements = document.querySelectorAll(inquiryTargetAppSelector);
const inquiryTargetApps = [];
if (inquiryTargetAppElements) {
    inquiryTargetAppElements.forEach(app => {
        const predefinedShops = app.dataset.predefinedShops;
        const predefinedBranch = app.dataset.predefinedBranch;
        const formFieldId = app.dataset.formFieldId;
        const branchesNodeId = app.dataset.branchesNodeId;
        const isCommercial = app.dataset.isCommercial;
        const seedData = {
            predefinedShops: predefinedShops,
            predefinedBranch:predefinedBranch,
            formFieldId: formFieldId,
            branchesNodeId: branchesNodeId,
            updateTarget:true,
            isCommercial:isCommercial == "True"
        };

        inquiryTargetApps.push(createApp({
            data() { return seedData },
            render: () => h(InquiryTarget)
        }, seedData).use(PrimeVue).mount('#' + app.id));
    });
}
